/**
 * Séquence 1 — Représentations individuelles autour de la conduite (30 min)
 *
 * S'appuie sur le questionnaire préalable rempli par l'élève.
 * Objectifs officiels : connaître l'élève · adapter l'enseignement ·
 * faire parler l'élève de son rapport à la conduite.
 */
export const sequence1 = {
  officiel: {
    objectifs: [
      "Connaître l'élève et adapter l'enseignement à son profil",
      "Faire parler l'élève sur son rapport à la conduite",
      'Travailler le respect des règles',
      'Aborder la signalisation',
      'Aborder les grandes thématiques de la sécurité routière',
    ],
    thematiques: [
      { key: 'vitesse',        label: 'Vitesse',                    desc: 'Rapport à la vitesse dans son environnement quotidien.' },
      { key: 'alcool',         label: 'Alcool & produits',          desc: 'Alcool et autres produits psychoactifs.' },
      { key: 'distracteurs',   label: 'Distracteurs',               desc: 'Téléphone, écouteurs, conversation, GPS.' },
      { key: 'rodeo',          label: 'Rodéo motorisé',             desc: 'Dangers et conséquences pénales.' },
      { key: 'pairs',          label: 'Influence des pairs',        desc: 'Pression sociale, groupe, réseaux sociaux.' },
      { key: 'autres-usagers', label: 'Comportement des autres',    desc: 'Anticiper les comportements des autres usagers.' },
    ],
  },
  enrichi: {
    accroche:
      "Cette première demi-heure fait tomber les masques. On échange AVANT de conduire, pour que ta formation soit vraiment adaptée à ce que tu penses de la route aujourd'hui — pas à ce que ton moniteur imagine que tu penses.",
    questionnaire: [
      { q: 'Tu es déjà monté à bord d’une voiturette avant ce jour ?',        type: 'oui-non' },
      { q: "Pour toi, une voiturette c'est plus proche d'une voiture ou d'un scooter ?", type: 'choix', options: ['Voiture', 'Scooter', "Je ne sais pas"] },
      { q: "Est-ce que la voiturette peut prendre l'autoroute ?",                 type: 'oui-non', bonus: 'Non — vitesse limitée 45 km/h : autoroutes et voies rapides interdites.' },
      { q: "À quel âge minimum peut-on conduire une voiturette ?",              type: 'choix', options: ['14 ans', '16 ans', '18 ans'] },
      { q: 'La ceinture de sécurité est-elle obligatoire dans une voiturette ?', type: 'oui-non', bonus: 'Oui — obligation expressément citée dans le référentiel officiel.' },
      { q: 'La voiturette peut transporter combien de passagers maximum ?',       type: 'choix', options: ['1', '2', '3'] },
    ],
    vraiFaux: [
      { affirmation: 'La voiturette peut rouler sur toutes les routes sauf les autoroutes.', reponse: true,  explication: "Vrai : elle est interdite sur autoroutes et voies pour automobiles (panneau bleu carré)." },
      { affirmation: "Une voiturette peut se conduire sans permis dès 14 ans.", reponse: false, explication: 'Faux : il faut le permis AM (ex-BSR) obtenu après formation de 8 h.' },
      { affirmation: "Je peux débrider ma voiturette pour dépasser 45 km/h.", reponse: false, explication: "Faux : délit passible d'amende, retrait véhicule, poursuites pénales." },
      { affirmation: "L'alcool est interdit même en voiturette.", reponse: true, explication: "Vrai : la réglementation alcool s'applique aussi aux voiturettes (0,5 g/L max)." },
    ],
    ouverture:
      "En fin d'échange, note dans le carnet de bord ce que tu attends de cette formation. On y reviendra en séquence 5.",
  },
};

export default sequence1;
